export default "__VITE_ASSET__Wr0l4mOw__"